import React from "react";
import TableRow from "../../../shortlisting/components/molecules/TableRow";

const ShortlistTable = ({ requests }) => {
  return (
    <div className="overflow-x-auto bg-white rounded shadow-md">
      <table className="min-w-full table-auto">
        <thead className="text-left bg-gray-100">
          <tr>
            {[
              "Candidate ID",
              "Full Name",
              "Email",
              "Gender",
              "Education Background",
              "Previous Job Position",
              "Status",
            ].map((h, i) => (
              <th key={i} className="p-4 text-sm font-semibold text-gray-700">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.isArray(requests) && requests.length > 0 ? (
            requests.map((row) => (
              <TableRow
                key={row.applicationId || row.candidateId}
                request={row}
              />
            ))
          ) : (
            <tr>
              <td colSpan={7} className="p-4 text-center text-gray-500">
                No shortlisted candidates available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ShortlistTable;
